import type {Context} from '../types';

const isBound = (data: any, context: string, propery: string) =>
  Boolean(
    data && data[context] && data[context].bind && data[context].bind[propery]
  );

export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;

  const {data = {}, type} = jsonNode;

  const isLightboxWrapper = type === 'LightboxWrapper';

  const isDynSrcBound = isBound(data, 'dyn', 'src');
  const isDynMediaBound = isBound(data, 'dyn', 'media');

  const isSearchSrcBound = isBound(data, 'search', 'src');
  const isSearchMediaBound = isBound(data, 'search', 'media');

  const isLightboxWrapperWithSrcBound =
    isLightboxWrapper && (isDynSrcBound || isSearchSrcBound);

  return {
    needed: isLightboxWrapperWithSrcBound,
    logData: {
      msg: 'Change the prop used for LightboxWrapper dynamic binding from src to media',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      if (isDynSrcBound) {
        if (!isDynMediaBound) {
          // populate `media` with the contents from `src`
          data.dyn.bind.media = data.dyn.bind.src;
        }
        // eslint-disable-next-line webflow/no-delete
        delete data.dyn.bind.src; // depopulate the `src` prop
      }

      if (isSearchSrcBound) {
        if (!isSearchMediaBound) {
          data.search.bind.media = data.search.bind.src;
        }
        // eslint-disable-next-line webflow/no-delete
        delete data.search.bind.src;
      }
    },
  };
};
